import {
    applyPolyfills,
    defineCustomElements
} from '@aws-amplify/ui-components/loader';

import { Amplify } from 'aws-amplify';

Amplify.configure({
    Auth: {
        region: process.env.VUE_APP_REGION,
        userPoolId: process.env.VUE_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
        oauth: {
            domain: process.env.VUE_APP_DOMAIN,
            scope: ['email', 'openid', 'profile'],
            redirectSignIn: process.env.VUE_APP_REDIRECT_SIGN_IN,
            redirectSignOut: process.env.VUE_APP_REDIRECT_SIGN_OUT,
            responseType: 'code', // 或 'token'
        },
        federationTarget: 'COGNITO_USER_POOLS',
        // OPTIONAL - customized storage object
        storage: window.sessionStorage,
    }
});
applyPolyfills().then(() => {
    defineCustomElements(window);
});
